module.exports = __webpack_public_path__ + "3e57fb801d1f28acabc63e590e7b42d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/Assets/shoppinglist.png
// module id = 1326
// module chunks = 0